import { IAction, getTheme_type } from "../actiontypes";
import { arrayToObject } from "../../utils";

export interface IThemeState {
    Name: string;
    LogoPath: string;
    PrimaryColor: string;
    SecondaryColor: string;
    IsBelmar: boolean;
    BaseUrl: string;
}

const initState: IThemeState = {
    "Name": "",
    "LogoPath": "",
    "PrimaryColor": "",
    "SecondaryColor": "",
    IsBelmar: false,
    BaseUrl: "https://sr.emedplus.com"
  };
  
  export const themeReducer = (state = initState, action: IAction): IThemeState => {
    switch (action.type) {
        case getTheme_type:
            let tenant = action.payload;
            let isBelmar = false;
            let baseUrl = "https://sr.emedplus.com";
            if(tenant) {
                isBelmar = tenant.Name?.toLowerCase() === 'belmar';
                if(isBelmar) baseUrl = "https://sr.belquestrx.com";
            }
            return {
                ...state,
                ...action.payload,
                IsBelmar: isBelmar,
                BaseUrl: baseUrl
            };
        default:
            return state;
    }
  };
